import { Pipe, PipeTransform } from "@angular/core";

@Pipe({name: "phoneNumber"})
export class PhoneNumberPipe implements PipeTransform {
    transform(number?: string) {
        // "2032123456"
        return `(${number.substring(0,3)}) ${number.substring(3,6)}-${number.substring(6)}`;
    }
}